import React, { Fragment } from 'react';
import { startCase } from 'lodash';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import qs from 'qs';

import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayCards from '../FieldArrayCards.jsx';

const arrDefaults = {
  extra: {
    walved: false,
    serviceType: '',
    service: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    status: '',
    deliServ: '',
    deliTrackNo: '',
    amount: 0,
    remarks: '',
    uom: 'EA',
    qty: 1,
    _id: '',
  },
};

const FieldExtraCards = ({
  extra = arrDefaults.extra, services = [], keyID = 'extra', notFixedQty = {}, disabled,
}) => {
  const { _id } = useParams();
  const { origin, pathname } = window.location;
  const [, , routeTypes] = pathname.split('/');

  return (
    <div className="row">
      <div className="col">
        <FieldArrayCards name={keyID} push={disabled ? undefined : extra} disabled={disabled}>
          {(s, i) => (
            <>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label>Waive</label>
                    <FormCheckGroup
                      name={`${keyID}[${i}].walved`}
                      type="checkbox"
                      label=""
                      disabled={disabled || Number(s.amount) === 0}
                      asSwitch
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name={`${keyID}[${i}].amount`} type="number" label="Amount" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${keyID}[${i}].serviceType`} label="Type" as="select" disabled={disabled}>
                    <option value="">-</option>
                    {['delivery', 'installation', 'additional'].map((v) => (
                      <option value={v} key={v}>
                        {startCase(v)}
                      </option>
                    ))}
                  </FormGroup>
                </div>
              </div>
              {s.serviceType === 'delivery' && (
                <Fragment>
                  <div className="row">
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].status`} label="Status" disabled={disabled} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].deliServ`} label="Service Provider" disabled={disabled} />
                    </div>
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].deliTrackNo`} label="Tracking number" disabled={disabled} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].startDate`} label="Start Date" type="date" disabled={disabled} />
                    </div>
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].startTime`} label="Start Time" type="time" disabled={disabled} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].endDate`} label="End Date" type="date" disabled={disabled} />
                    </div>
                    <div className="col">
                      <FormGroup name={`${keyID}[${i}].endTime`} label="End Time" type="time" disabled={disabled} />
                    </div>
                  </div>
                </Fragment>
              )}
              {s.serviceType === 'additional' && (
                <div className="row">
                  <div className="col">
                    <FormGroup
                      name={`${keyID}[${i}].service`}
                      label="Additional Service Type"
                      as="select"
                      disabled={disabled}>
                      <option value=""> - </option>
                      {services.map((v) => (
                        <option value={v._id} key={v._id}>
                          {`${v.itemCode} - ${v.description}`}
                        </option>
                      ))}
                    </FormGroup>
                  </div>
                </div>
              )}
              {notFixedQty[s.service] && (
                <div className="row">
                  <div className="col">
                    <FormGroup
                      name={`${keyID}[${i}].uom`}
                      label="UOM"
                      value={notFixedQty?.[s.service]?.uom || 'EA'}
                      onChange={() => {}}
                      disabled
                    />
                  </div>
                  <div className="col">
                    <FormGroup name={`${keyID}[${i}].qty`} label="Quantity" type="number" disabled={disabled} />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col">
                  <FormGroup name={`${keyID}[${i}].remarks`} label="Remark" disabled={disabled} />
                </div>
              </div>
              {s.serviceType === 'delivery'
                && ['orders', 'consignments', 'quotations'].includes(routeTypes) && (
                  <Fragment>
                    <div className="row">
                      <div className="col d-flex">
                        <a
                          className="btn btn-warning"
                          type="button"
                          disabled={!s._id}
                          icon={faPrint}
                          href={`${origin}/api/core/${routeTypes}/delivery?${qs.stringify({
                            _id,
                            extraId: i,
                            utcOffset: moment().utcOffset(),
                          })}`}
                          target="_blank"
                          rel="noreferrer">
                          Delivery Note
                        </a>
                        <p className="my-auto mx-2">Please save document to reflect changes</p>
                      </div>
                    </div>
                  </Fragment>
              )}
            </>
          )}
        </FieldArrayCards>
      </div>
    </div>
  );
};

export default FieldExtraCards;
